import { useState } from 'react';
import './MultiLicensesStatus.css';
import ModalComponent from '../Modal/ModalComponent';
import List from '../List/List';
import { useUserStore } from '../../contexts/userStore';

export function MultiLicensesStatus({ id, listEntityName, licenses, showableModal = true }) {
   const [showModal, setShowModal] = useState(false);
   const { condominiums, clientLicenses } = useUserStore();

   if (!licenses || licenses.length === 0) {
      return (
         <span className="opacity-40 text-(--textColor) my-[0.2rem]! block">Sem vínculos</span>
      );
   }
   const total = licenses?.length ?? 0;
   const totalSynced = licenses?.filter(l => l.status === 'synced')?.length ?? 0;
   const totalStarted = licenses?.filter(l => l.status === 'started')?.length ?? 0;
   const totalErrors = licenses?.filter(l => l.status.startsWith('0x') || l.status === 'error')?.length ?? 0;

   function getOwnerUnitName(license) {
      const condominium = condominiums.find(c => Number(c.id) === Number(license.ownerUnitId));
      return condominium?.name;
   }

   function getSerialNumber(license) {
      const clientLicense = clientLicenses.find(l => Number(l.id) === Number(license.licenseId));
      return clientLicense?.SN_equipment;
   }

   function getLastOperation(license) {
      if (license.last_operation === 'update') return 'Atualização'
      if (license.last_operation === 'post') return 'Criação'
      if (license.last_operation === 'delete') return 'Remoção'
      return <span className="opacity-40">Nenhuma operação</span>
   }

   return (
      <>
         <div className='flex flex-row items-center justify-center w-fit! h-full! hover:opacity-75 duration-200! cursor-pointer'
            onClick={(e) => {
               e.stopPropagation();
               if (showableModal) setShowModal(true);
            }}>
            <div className="multi-licenses-status">
               {totalSynced > 0 && (
                  <span className="licenses-synced-bar" style={{ width: `calc(${(totalSynced / total) * 100}%)` }}></span>
               )}
               {totalStarted > 0 && (
                  <span className="licenses-started-bar" style={{ width: `calc(${(totalStarted / total) * 100}%)` }}></span>
               )}
               {totalErrors > 0 && (
                  <span className="licenses-error-bar" style={{ width: `calc(${(totalErrors / total) * 100}%)` }}></span>
               )}
               {total - (totalSynced + totalErrors + totalStarted) > 0 && (
                  <span className="licenses-not-synced-bar" style={{ width: `calc(${((total - (totalSynced + totalErrors + totalStarted)) / total) * 100}%)` }}></span>
               )}
            </div>
         </div>
         <ModalComponent
            modalIsOpen={showModal}
            modalText={
               "Sincronização com os equipamentos"
            }
            hideConfirmButton={true}
            handleCancel={() => setShowModal(false)}
         >
            <div className="flex flex-col gap-2">
               <div className="list-visibility" style={{ width: "800px" }}>
                  <List
                     selectable={false}
                     listEntityName={listEntityName}
                     collumsObjIndex={[
                        { collumnLabel: "Licença", type: "custom", custom: ({ row }) => getOwnerUnitName(row) },
                        { collumnLabel: "Número de série", type: "custom", custom: ({ row }) => getSerialNumber(row) },
                        { collumnLabel: "Última operação", type: "custom", custom: ({ row }) => getLastOperation(row) },
                        { collumnLabel: "Status", index: "status", type: "sync-status" },
                     ]}
                     data={licenses.map(l => ({ ...l, id }))}
                  />
               </div>
            </div>
         </ModalComponent>
      </>
   );
}